<script lang="ts">
  import JsApi from '@tencent/tvf-jsapi';
  import { createEventDispatcher } from 'svelte';

  import Button from '@/comps-sdk/components/button';
  export let receiveResult: any = {};
  // const context: any = getContext(EActCommonReceive.CONTEXT_INTERFACE_KEY) as IActCommonReceive.CompContextInterface;

  // if (!ZoneRoleSelect) {
  //   const context: any = getContext(EActCommonReceive.CONTEXT_INTERFACE_KEY) as IActCommonReceive.CompContextInterface;
  //   ZoneRoleSelect = context?.ZoneRoleSelect;
  // }
  // const context = getAllContexts();
  // const openPage = context?.get('openPage');

  // console.log('context', context);
  $: showResult = receiveResult?.showResult;
  $: successMode = receiveResult?.code === 0;
  $: errorMsg = receiveResult?.msg ?? '领取失败了，请稍后再试～';
  $: pkgId = '';
  $: {
    const { propertyData } = receiveResult;
    const [propertyDataFirst] = propertyData;
    console.log('propertyDataFirst', propertyDataFirst);
    const giftData = JSON.parse(propertyDataFirst.propertyDetail.desc.delivery_plat.extends);
    pkgId = giftData.gift_present_info.ext.dressing_pkg_id;
    console.log('pkgId', pkgId);
  }

  const dispatch = createEventDispatcher();
  const handleBtnClick = () => {
    const domain = 'm.v.qq.com';
    JsApi.invoke('openUrl', {
      url: `https://${domain}/z/comet/dressing-center/index.html?isOpenView=1&hidetitlebar=1&ovscroll=0#/detail/?pkg_id=${pkgId}&from_p=full`,
    });
    dispatch('close');
  };
</script>

<div class="result-panel">
  <div class="result-header">
    {showResult.title}
  </div>
  <div class="result-content">
    <div class="result-desc">
      {successMode ? showResult.desc : errorMsg}
    </div>
    {#if showResult.img}
      <div class="result-img-wrapper">
        <img class="result-img" src={showResult.img} alt="" />
      </div>
    {/if}
  </div>
  <div class="btn-wrapper">
    <Button on:click={handleBtnClick}>前往装扮</Button>
  </div>
</div>

<style lang="scss">
  .result-panel {
    padding: 0 15px;
    min-height: 30vh;
    display: flex;
    flex-direction: column;
    .result-header {
      margin-top: 15px;
      text-align: center;
      font-family: PingFangSC-Medium;
      font-size: 18px;
      color: #191919;
    }
    .result-content {
      flex: 1;
      margin: 12px 0;
      text-align: center;
      .result-desc {
        padding: 0 15px;
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #191919;
      }
      .result-img-wrapper {
        margin-top: 24px;
        .result-img {
          width: auto;
          max-width: 100%;
          max-height: 140px;
          border-radius: 6px;
        }
      }
    }
    .btn-wrapper {
      margin: 10px;
      text-align: center;
    }
  }
</style>
